
import { FileText, Menu, CheckCircle, XCircle, ArrowRight } from 'lucide-react';
import '../../../../assets/css/Ngo/controlpanelCSS/Dashboard.css';
import NgoLayout from '../../../../layouts/Ngo/NgoLayout';
import React, { useState, useEffect } from 'react';
import VerificationModal from '../../../../components/student/verificationModal/VerificationModal';

// Data
const dashboardData = {
  stats: [
    { label: 'Total Requests', value: '320', icon: 'FileText', className: 'total' },
    { label: 'Pending Verification', value: '85', icon: 'Menu', className: 'pending' },
    { label: 'Approved Cases', value: '150', icon: 'CheckCircle', className: 'approved' },
    { label: 'Rejected Cases', value: '45', icon: 'XCircle', className: 'rejected' }
  ],
  donations: [
    { id: 1, student: 'Ali Ahmad', type: 'School Fee', amount: 20000, status: 'Pending', date: '15 Jan 2026', school: 'Govt High School' },
    { id: 2, student: 'Sana Khalid', type: 'Books & Stationery', amount: 5000, status: 'Approved', date: '14 Jan 2026', school: 'Allied School' },
    { id: 3, student: 'Ahmed Raza', type: 'Uniform', amount: 4000, status: 'Rejected', date: '13 Jan 2026', school: 'City School' },
    { id: 4, student: 'Ayesha Bibi', type: 'School Fee', amount: 15000, status: 'Pending', date: '12 Jan 2026', school: 'Punjab College' },
  ]
};

// Utils
const formatCurrency = (amount) => {
  return `Rs ${amount.toLocaleString('en-IN')}`;
};

const getStatusClass = (status) => {
  return status.toLowerCase();
};

const getIconComponent = (iconName) => {
  const icons = { FileText, Menu, CheckCircle, XCircle };
  return icons[iconName] || FileText;
};

// Components
const StatsCard = ({ stat }) => {
  const Icon = getIconComponent(stat.icon);
  return (
    <div className={`ngo-stat-card ${stat.className}`}>
      <div className="ngo-stat-icon">
        <Icon size={24} />
      </div>
      <div className="ngo-stat-content">
        <div className="ngo-stat-label">{stat.label}</div>
        <div className="ngo-stat-value">{stat.value}</div>
      </div>
    </div>
  );
};

const DonationsTable = ({ donations }) => {
  return (
    <div className="ngo-table-section">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
        <h2 className="ngo-section-title" style={{ margin: 0 }}>Recent Donation Requests</h2>
        <button 
          className="ngo-view-all-btn" 
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.625rem 1.25rem',
            backgroundColor: '#3b82f6',
            color: 'white',
            border: 'none',
            borderRadius: '0.5rem',
            fontSize: '0.875rem',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.2s',
            boxShadow: '0 2px 4px rgba(59, 130, 246, 0.2)'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#2563eb';
            e.target.style.boxShadow = '0 4px 6px rgba(59, 130, 246, 0.3)';
            e.target.style.transform = 'translateY(-1px)';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#3b82f6';
            e.target.style.boxShadow = '0 2px 4px rgba(59, 130, 246, 0.2)';
            e.target.style.transform = 'translateY(0)';
          }}
          onClick={() => {
            // Navigate to all cases - Add your navigation logic here
           Example: window.location.href = '/ngo/Allcases';
            console.log('Allcases');
          }}
        >
          View All Cases
          <ArrowRight size={16} />
        </button>
      </div>
      <div className="ngo-table-wrapper">
        <table className="ngo-table">
          <thead>
            <tr>
              <th>Student Name</th>
              <th>School</th>
              <th>Request Type</th>
              <th>Amount</th>
              <th>Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {donations.map(donation => (
              <tr key={donation.id}>
                <td className="ngo-student-name" style={{ fontWeight: '500' }}>{donation.student}</td>
                <td style={{ color: '#6b7280' }}>{donation.school}</td>
                <td>{donation.type}</td>
                <td style={{ fontWeight: '600', color: '#111827' }}>{formatCurrency(donation.amount)}</td>
                <td style={{ color: '#6b7280' }}>{donation.date}</td>
                <td>
                  <span className={`ngo-status-badge ${getStatusClass(donation.status)}`}>
                    {donation.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      <div className="ngo-pagination">
        <button className="ngo-pagination-btn">←</button>
        <span className="ngo-pagination-info">Page 1 of 10</span>
        <div className="ngo-pagination-dots">
          <div className="ngo-pagination-dot active"></div>
          <div className="ngo-pagination-dot"></div>
        </div>
        <span className="ngo-pagination-next">Next</span>
        <button className="ngo-pagination-btn">→</button>
      </div>
    </div>
  );
};

const ChartsSection = () => {
  return (
    <div className="ngo-charts-grid">
      <div className="ngo-chart-card">
        <h3 className="ngo-chart-title">Donations by Category</h3>
        <div className="ngo-pie-chart">
          <div className="ngo-pie-visual"></div>
          <div className="ngo-pie-legend">
            <div className="ngo-legend-item">
              <div className="ngo-legend-color fee"></div>
              <div className="ngo-legend-label">
                <span className="ngo-legend-name">Fee</span>
                <span className="ngo-legend-percent">55%</span>
              </div>
            </div>
            <div className="ngo-legend-item">
              <div className="ngo-legend-color books"></div>
              <div className="ngo-legend-label">
                <span className="ngo-legend-name">Books</span>
                <span className="ngo-legend-percent">25%</span>
              </div>
            </div>
            <div className="ngo-legend-item">
              <div className="ngo-legend-color uniform"></div>
              <div className="ngo-legend-label">
                <span className="ngo-legend-name">Uniform</span>
                <span className="ngo-legend-percent">20%</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="ngo-chart-card">
        <h3 className="ngo-chart-title">Monthly Requests & Donations</h3>
        <div className="ngo-chart-legend">
          <div className="ngo-legend-item">
            <div className="ngo-legend-dot requests"></div>
            <span className="ngo-legend-name">Requests</span>
          </div>
          <div className="ngo-legend-item">
            <div className="ngo-legend-dot donations"></div>
            <span className="ngo-legend-name">Donations</span>
          </div>
        </div>
        <div className="ngo-line-chart">
          <svg width="100%" height="280" viewBox="0 0 700 280" preserveAspectRatio="xMidYMid meet">
            <line x1="50" y1="20" x2="50" y2="240" stroke="#e5e7eb" strokeWidth="2"/>
            <line x1="50" y1="240" x2="680" y2="240" stroke="#e5e7eb" strokeWidth="2"/>
            <polyline points="100,180 200,120 300,140 400,60 500,100 600,120 650,80" fill="none" stroke="#3b82f6" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
            <polyline points="100,210 200,200 300,230 400,170 500,190 600,210 650,150" fill="none" stroke="#10b981" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="100" cy="180" r="5" fill="#3b82f6"/>
            <circle cx="200" cy="120" r="5" fill="#3b82f6"/>
            <circle cx="300" cy="140" r="5" fill="#3b82f6"/>
            <circle cx="400" cy="60" r="5" fill="#3b82f6"/>
            <circle cx="500" cy="100" r="5" fill="#3b82f6"/>
            <circle cx="600" cy="120" r="5" fill="#3b82f6"/>
            <circle cx="650" cy="80" r="5" fill="#3b82f6"/>
            <circle cx="100" cy="210" r="5" fill="#10b981"/>
            <circle cx="200" cy="200" r="5" fill="#10b981"/>
            <circle cx="300" cy="230" r="5" fill="#10b981"/>
            <circle cx="400" cy="170" r="5" fill="#10b981"/>
            <circle cx="500" cy="190" r="5" fill="#10b981"/>
            <circle cx="600" cy="210" r="5" fill="#10b981"/>
            <circle cx="650" cy="150" r="5" fill="#10b981"/>
            <text x="100" y="260" textAnchor="middle" fontSize="13" fill="#6b7280">Jan</text>
            <text x="200" y="260" textAnchor="middle" fontSize="13" fill="#6b7280">Feb</text>
            <text x="300" y="260" textAnchor="middle" fontSize="13" fill="#6b7280">Mar</text>
            <text x="400" y="260" textAnchor="middle" fontSize="13" fill="#6b7280">Apr</text>
            <text x="500" y="260" textAnchor="middle" fontSize="13" fill="#6b7280">May</text>
            <text x="600" y="260" textAnchor="middle" fontSize="13" fill="#6b7280">Jun</text>
            <text x="650" y="260" textAnchor="middle" fontSize="13" fill="#6b7280">Jul</text>
          </svg>
        </div>
      </div>
    </div>
  );
};

// Main Component
const NGODashboard = () => {
    const [showVerification, setShowVerification] = useState(true);

  // useEffect(() => {
  //   const isVerified = localStorage.getItem("Ngo_verified");

  //   if (!isVerified) {
  //     setShowVerification(true);
  //   }
  // }, []);
  return (<NgoLayout>
    <div className="ngo-dashboard">
      <section className="ngo-stats-section">
        <div className="ngo-stats-grid">
          {dashboardData.stats.map((stat, index) => (
            <StatsCard key={index} stat={stat} />
          ))}
        </div>
      </section>

      <main className="ngo-main-content">
        <ChartsSection />
        <DonationsTable donations={dashboardData.donations} />
      </main>
    </div>
    {showVerification && (
  <VerificationModal
   show={showVerification}
    type="ngo"
    onClose={() => setShowVerification(false)}
    // onClose={() => setShowVerification(false)}
  />
)}
    </NgoLayout>
  );
};

export default NGODashboard;